import { accessInAU } from './ec-constant';
import { EcEnv } from './ec-env';

const showLoyaltyV2Requirements = EcEnv.NEXT_PUBLIC_YOTPO_ENABLED;

export const basePageConfig = {
  home: '/',
  login: '/login',
  signup: '/signup',
  'forgot-password': '/forgot-password',
  unsubscribe: '/unsubscribe',
  wishlist: '/wishlist',
  'wishlist-products': '/wishlist/products',
  'wishlist-looks': '/wishlist/looks',
  'shop-the-look': '/shop-the-look',
  'stl-living-room': '/shop-the-look/living-room',
  'stl-dining-room': '/shop-the-look/dining-room',
  'stl-bedroom': '/shop-the-look/bedroom',
  'stl-outdoor': '/shop-the-look/outdoor',
  'stl-by-collection': '/shop-the-look/by-collection',
  'virtual-studio': '/virtual-studio',
  'stay-home': '/stay-home',
  blog: '/blog',
  'furniture-configurator-tool': '/furniture-configurator-tool',
  o2o: '/showroom-exclusives',
  'interior-styling-service': '/interior-styling-service',
  profile: '/account/profile',
  orders: '/account/orders',
  vouchers: '/account/vouchers',
  address: '/account/address',
  rewards: '/account/the-castlery-club',

  'order-details': '/account/order-details',
  'submit-review': '/submit-review',
  'my-reviews': '/account/reviews',
  cart: '/cart',
  'checkout-account': '/checkout/account',
  'checkout-shipping-address': '/checkout/shipping-address',
  'checkout-shipping-method': '/checkout/shipping-method',
  'checkout-payment': '/checkout/payment',
  'checkout-2c2p': '/checkout/tctp-payment',
  'checkout-grabpay': '/checkout/grabpay',
  'checkout-success': '/checkout/success',
  'checkout-empty': '/checkout/empty-cart',
  'contact-us': '/contact-us',
  'our-story': '/our-story',
  'manufacturing-quality': '/manufacturing-quality',
  studio: '/studio',
  showroom: '/showroom',
  'sydney-showroom': '/sydney-showroom',
  swatches: '/swatches',
  zip: '/zip',
  trade: '/trade',
  'affiliate-program': '/affiliate-program',
  delivery: '/delivery',
  accessibility: '/accessibility',
  'referral-terms': '/referral-terms',
  'referral-issue': '/referral-issue',
  press: '/press',
  'terms-of-use': '/terms-of-use',
  'sales-and-refunds': '/sales-and-refunds',
  'store-credits-terms': '/the-castlery-club-terms',
  warranty: '/warranty',
  'promo-terms': '/promo-terms',
  'privacy-policy': '/privacy-policy',
  'help-center': '/help-center',
  'reset-password': '/reset-password',
  reviews: '/reviews',
  'at-home-with-castlery': '/at-home-with-castlery',
  'accident-protection-plan-faq': '/accident-protection-plan-faq',
  'style-contest': '/styling-contest',
  'schedule-delivery': '/schedule-delivery',
  'delivery-review': '/delivery-review',
  feat: '/feat',
  'interior-design': '/interior-design',
  designers: '/designers',
  'designer-community': '/designer-community',
  'birthday-sale': '/birthday-sale',
  'warehouse-sale': '/warehouse-sale',
  'warehouse-sale-tutorial': '/warehouse-sale-tutorial',
  rsvp: '/rsvp',
  christmas: '/christmas',
  'new-year': '/new-year',
  'lunar-new-year': '/lunar-new-year',
  'mid-year-sale': accessInAU ? '/eofy-sale' : '/midyear-sale',
  'new-way-of-living': '/new-way-of-living',
  'furniture-sydney': '/furniture-sydney',
  'furniture-melbourne': '/furniture-melbourne',
  'new-homeowners': '/new-homeowners',
  'celebrate-home-giveaway': '/celebrate-home-giveaway',
  product: '/products',
  pla: '/pla',
  search: '/search',
  'as-is': '/as-is',
  'asis-beds': '/as-is/beds',
  collections: '/collections',
  referral: '/referral',
  'the-castlery-club': '/the-castlery-club',
  mindscape: '/mindscape',
  rich: '/rich',
  wondery: '/wondery',
  thedollop: '/thedollop',
  eventherich: '/eventherich',
  sitemap: '/sitemap',
  'room-designer': '/room-designer',
} as const;
